module.exports = __webpack_public_path__ + "img/mango.e2422f61.png";